import React, { useEffect, useState } from 'react';
import './CatalogoProveedores.scss';
import { addVendorCatalog, getClientsCatalog, getVendorCatalogById, getVendorCategory, getCiudad, updateVendorCatalogService } from './proveedoresIntegracion';
import { FilterMatchMode } from 'primereact/api';
import ProveedoresTable from './ProveedoresTable';
import TableHeader from './TableHeader';
import ProveedorFormModal from './ProveedorFormModal';
import Swal from 'sweetalert2';
import { formatearFechaHora } from '../../../utilidades/formateos';

const CatalogoProveedores = () => {
    const [clientsCatalog, setClientsCatalog] = useState([]);
    const [filteredCatalog, setFilteredCatalog] = useState([]);
    const [showOnlyActive, setShowOnlyActive] = useState(true);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        CATEGORIA: { value: null, matchMode: FilterMatchMode.EQUALS },
        ULTIMA_COMPRA_FECHA: { value: null, matchMode: FilterMatchMode.DATE_IS }
    });
    const [showDialog, setShowDialog] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState({
        ID: null,
        NOMBRE: '',
        RAZON_SOCIAL: '',
        RFC: '',
        DIRECCION: '',
        COLONIA: '',
        CIUDAD: '',
        HORARIO: '',
        CATEGORIA: null,
        TELEFONO: '',
        PAGINA: '',
        CORREO: '',
        CONTACTO1: '',
        CONTACTO2: '',
        ODOO: null,
        ACTIVO: true,
        DIRECTORIO: false,
        CP: '',
        TELEFONO2: '',
        BANCO: '',
        CUENTA_NOMBRE: '',
        CUENTA: '',
        CLAVE: '',
        TARJETA_CREDITO: '',
        SERVICIOS: '',
        NOTA: '',
        DIAS_CREDITO: 0
    });

    useEffect(() => {
        getProviders();
        loadCategorias();
        loadCiudades();
    }, []);

    useEffect(() => {
        applyActiveFilter();
    }, [clientsCatalog, showOnlyActive]);

    const getProviders = async () => {
        const response = await getClientsCatalog();
        if (response) {
            setClientsCatalog(response);
        }
    };

    const applyActiveFilter = () => {
        if (showOnlyActive) {
            setFilteredCatalog(clientsCatalog.filter(item => item.ACTIVO === true));
        } else {
            setFilteredCatalog(clientsCatalog);
        }
    };

    const toggleActiveFilter = () => {
        setShowOnlyActive(!showOnlyActive);
    };

    const loadCategorias = async () => {
        // Aquí deberías cargar las categorías desde tu endpoint
        // const response = await getCategorias();
        // setCategorias(response);

        // Ejemplo temporal:
        await getVendorCategory().then((response) => {
            setCategorias(response);
        });
    };
    const loadCiudades = async () => {
        await getCiudad().then((response) => {
            setCiudades(response);
        });
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const openNew = () => {
        setSelectedProvider({
            ID: null,
            NOMBRE: '',
            RAZON_SOCIAL: '',
            RFC: '',
            DIRECCION: '',
            COLONIA: '',
            CIUDAD: '',
            HORARIO: '',
            CATEGORIA: null,
            TELEFONO: '',
            PAGINA: '',
            CORREO: '',
            CONTACTO1: '',
            CONTACTO2: '',
            ODOO: null,
            ACTIVO: true,
            DIRECTORIO: false,
            CP: '',
            TELEFONO2: '',
            BANCO: '',
            CUENTA_NOMBRE: '',
            CUENTA: '',
            CLAVE: '',
            TARJETA_CREDITO: '',
            SERVICIOS: '',
            NOTA: '',
            DIAS_CREDITO: 0
        });
        setIsEditing(false);
        setShowDialog(true);
    };

    const editProvider = async (provider) => {
        const response = await getVendorCatalogById(provider.ID);
        if (response) {
            // Mapear los datos del backend al formato del formulario
            const mappedProvider = {
                ID: provider.ID,
                NOMBRE: response.NOMBRE?.trim() || '',
                RAZON_SOCIAL: response.RAZON_SOCIAL?.trim() || '',
                RFC: response.RFC?.trim() || '',
                DIRECCION: response.DIRECCION?.trim() || '',
                COLONIA: response.COLONIA?.trim() || '',
                CIUDAD: response.ID_CIUDAD && response.NOMBRE_CIUDAD ? {
                    code: response.ID_CIUDAD,
                    name: response.NOMBRE_CIUDAD?.trim()
                } : null,
                HORARIO: response.HORARIO?.trim() || '',
                CATEGORIA: response.ID_CATEGORIA && response.CATEGORIA ? {
                    code: response.ID_CATEGORIA,
                    name: response.CATEGORIA?.trim()
                } : null,
                ID_CATEGORIA: response.ID_CATEGORIA || null,
                TELEFONO: response.TELEFONO1?.trim() || '',
                TELEFONO1: response.TELEFONO1?.trim() || '',
                TELEFONO2: response.TELEFONO2?.trim() || '',
                PAGINA: response.PAGINA?.trim() || '',
                CORREO: response.CORREO?.trim() || '',
                CONTACTO1: response.CONTACTO1?.trim() || '',
                CONTACTO2: response.CONTACTO2?.trim() || '',
                ODOO: response.ODOO_ID || null,
                ODOO_ID: response.ODOO_ID || null,
                ACTIVO: response.ACTIVO || false,
                DIRECTORIO: response.DIRECTORIO || false,
                CP: response.CP?.trim() || '',
                BANCO: response.BANCO?.trim() || '',
                CUENTA_NOMBRE: response.CUENTA_NOMBRE?.trim() || '',
                CUENTA: response.CUENTA?.trim() || '',
                CLAVE: response.CLABE?.trim() || '',
                CLABE: response.CLABE?.trim() || '',
                TARJETA_CREDITO: response.TARJETA?.trim() || '',
                TARJETA: response.TARJETA?.trim() || '',
                SERVICIOS: response.SERVICIOS || '',
                NOTA: response.NOTA || '',
                DIAS_CREDITO: response.DIAS_CREDITO || 0
            };
            setSelectedProvider(mappedProvider);
            setIsEditing(true);
            setShowDialog(true);
        }
    };

    const hideDialog = () => {
        setShowDialog(false);
        getProviders();
    };

    const saveProvider = async () => {
        // Validar campos obligatorios
        const camposObligatorios = [
            { campo: 'NOMBRE', nombre: 'Nombre' },
            { campo: 'RAZON_SOCIAL', nombre: 'Razón Social' },
            { campo: 'RFC', nombre: 'RFC' },
            { campo: 'DIRECCION', nombre: 'Dirección' },
            { campo: 'COLONIA', nombre: 'Colonia' },
            { campo: 'CIUDAD', nombre: 'Ciudad' },
            { campo: 'CP', nombre: 'Código Postal' },
            { campo: 'CATEGORIA', nombre: 'Categoría' },
            { campo: 'TELEFONO', nombre: 'Teléfono 1' },
            { campo: 'CORREO', nombre: 'Correo' },
            { campo: 'CONTACTO1', nombre: 'Contacto 1' },
            { campo: 'BANCO', nombre: 'Banco' },
            { campo: 'CUENTA_NOMBRE', nombre: 'Nombre de Cuenta' },
            { campo: 'CUENTA', nombre: 'Número de Cuenta' },
            { campo: 'CLAVE', nombre: 'CLABE' }
        ];

        const camposFaltantes = [];
        for (const { campo, nombre } of camposObligatorios) {
            const valor = selectedProvider[campo];
            if (!valor || (typeof valor === 'string' && valor.trim() === '') || (typeof valor === 'object' && !valor.code)) {
                camposFaltantes.push(nombre);
            }
        }

        if (camposFaltantes.length > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos Obligatorios',
                html: `Por favor complete los siguientes campos:<br><strong>${camposFaltantes.join(', ')}</strong>`,
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // Preparar datos en el formato del backend
        const dataToSend = {
            ACTIVO: selectedProvider.ACTIVO || false,
            BANCO: selectedProvider.BANCO || '',
            CATEGORIA: selectedProvider.CATEGORIA?.code || '',
            CIUDAD: selectedProvider.CIUDAD?.code || '',
            CLABE: selectedProvider.CLAVE || selectedProvider.CLABE || '',
            COLONIA: selectedProvider.COLONIA || '',
            NOMBRE_CONTACTO1: selectedProvider.CONTACTO1 || '',
            NOMBRE_CONTACTO2: selectedProvider.CONTACTO2 || '',
            CORREO: selectedProvider.CORREO || '',
            CP: selectedProvider.CP || '',
            CUENTA: selectedProvider.CUENTA || '',
            CUENTA_NOMBRE: selectedProvider.CUENTA_NOMBRE || '',
            DIAS_CREDITO: selectedProvider.DIAS_CREDITO || 0,
            DIRECCION: selectedProvider.DIRECCION || '',
            DIRECTORIO: selectedProvider.DIRECTORIO || false,
            HORARIO: selectedProvider.HORARIO || '',
            NOMBRE: selectedProvider.NOMBRE || '',
            NOTA: selectedProvider.NOTA || null,
            ODOO_ID: selectedProvider.ODOO || selectedProvider.ODOO_ID || null,
            PAGINA: selectedProvider.PAGINA || '',
            RAZON_SOCIAL: selectedProvider.RAZON_SOCIAL || '',
            RFC: selectedProvider.RFC || '',
            SERVICIOS: selectedProvider.SERVICIOS || null,
            TARJETA: selectedProvider.TARJETA_CREDITO || selectedProvider.TARJETA || '',
            TELEFONO1: selectedProvider.TELEFONO || selectedProvider.TELEFONO1 || '',
            TELEFONO2: selectedProvider.TELEFONO2 || ''
        };

        if (isEditing) {
            // Agregar ID para actualización
            dataToSend.ID = selectedProvider.ID;
            const updatedCatalog = clientsCatalog.map(item =>
                item.ID === selectedProvider.ID ? {
                    ...selectedProvider,
                    CATEGORIA: selectedProvider.CATEGORIA?.name || selectedProvider.CATEGORIA,
                    CIUDAD: selectedProvider.CIUDAD?.name || selectedProvider.CIUDAD
                } : item
            );
            await updateVendorCatalogService(dataToSend)
            const updatedCatalogFromServer = await getClientsCatalog()
            setClientsCatalog(updatedCatalogFromServer);
        } else {
            // await createProvider(dataToSend);
            await addVendorCatalog(dataToSend)
                .then((response) => {
                    if (response.originalError) {
                        Swal.fire('Error', 'Hubo un problema al crear el proveedor', 'error');
                    }
                    else {

                        Swal.fire('Éxito', 'Proveedor creado correctamente', 'success');
                    }
                })
                .catch((error) => {
                    Swal.fire('Error', 'Hubo un problema al crear el proveedor', 'error');
                })

            const updatedCatalogFromServer = await getClientsCatalog()
            setClientsCatalog(updatedCatalogFromServer);
        }
        setShowDialog(false);
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _provider = { ...selectedProvider };
        _provider[name] = val;
        setSelectedProvider(_provider);
    };

    const onInputNumberChange = (e, name) => {
        const val = e.value || 0;
        let _provider = { ...selectedProvider };
        _provider[name] = val;
        setSelectedProvider(_provider);
    };

    const onCheckboxChange = (e, name) => {
        let _provider = { ...selectedProvider };
        _provider[name] = e.checked;
        setSelectedProvider(_provider);
    };

    const onDropdownChange = (e, name) => {
        let _provider = { ...selectedProvider };
        _provider[name] = e.value;
        setSelectedProvider(_provider);
    };

    const onCalendarChange = (e, name) => {
        let _provider = { ...selectedProvider };
        _provider[name] = e.value;
        setSelectedProvider(_provider);
    };

    const onCategoryFilterChange = (e) => {
        let _filters = { ...filters };
        _filters['CATEGORIA'].value = e.value;
        setFilters(_filters);
    };

    const onDateFilterChange = (e) => {
        let _filters = { ...filters };
        _filters['ULTIMA_COMPRA_FECHA'].value = e.value;
        setFilters(_filters);
    };

    return (
        <div className="catalogo-proveedores">
            <ProveedoresTable
                data={filteredCatalog}
                filters={filters}
                globalFilterFields={['NOMBRE', 'RFC', 'CORREO', 'TELEFONO']}
                onEdit={editProvider}
                header={
                    <TableHeader
                        globalFilterValue={globalFilterValue}
                        onGlobalFilterChange={onGlobalFilterChange}
                        filters={filters}
                        onCategoryFilterChange={onCategoryFilterChange}
                        onDateFilterChange={onDateFilterChange}
                        categorias={categorias}
                        onCreateNew={openNew}
                        showOnlyActive={showOnlyActive}
                        onToggleActiveFilter={toggleActiveFilter}
                    />
                }
            />

            <ProveedorFormModal
                visible={showDialog}
                isEditing={isEditing}
                provider={selectedProvider}
                categorias={categorias}
                ciudades={ciudades}
                onCalendarChange={onCalendarChange}
                onHide={hideDialog}
                onSave={saveProvider}
                onInputChange={onInputChange}
                onInputNumberChange={onInputNumberChange}
                onCheckboxChange={onCheckboxChange}
                onDropdownChange={onDropdownChange}
            />
        </div>
    )
};

export default CatalogoProveedores;